export const DELETE_DEVICE_REQUEST = 'DEVICES/DELETE/REQUEST';
export const DELETE_DEVICE_SUCCESS = 'DEVICES/DELETE/SUCCESS';
export const DELETE_DEVICE_FAILURE = 'DEVICES/DELETE/FAILURE';

export const FETCH_DEVICES_REQUEST = 'DEVICES/FETCH/REQUEST';
export const FETCH_DEVICES_SUCCESS = 'DEVICES/FETCH/SUCCESS';
export const FETCH_DEVICES_FAILURE = 'DEVICES/FETCH/FAILURE';

export const CREATE_DEVICE_REQUEST = 'DEVICES/CREATE/REQUEST';
export const CREATE_DEVICE_SUCCESS = 'DEVICES/CREATE/SUCCESS';
export const CREATE_DEVICE_FAILURE = 'DEVICES/CREATE/FAILURE';

export const CLEAN_DEVICES = 'DEVICES/CLEAN';
export const CLEAN_CREATED_DEVICE = 'CREATED_DEVICES/CLEAN';

export const SET_FILTER = 'DEVICES/FILTERS/SET';
export const CLEAR_FILTER = 'DEVICES/FILTERS/CLEAR';
export const REMOVE_FILTER = 'DEVICES/FILTERS/REMOVE';

export const DEVICE_NAME_CHECK_REQUEST = 'CREATED_DEVICES/NAME_REQUEST';
export const DEVICE_NAME_CHECK_SUCCESS = 'CREATED_DEVICES/NAME_SUCCESS';
export const DEVICE_NAME_CHECK_FAILURE = 'CREATED_DEVICES/NAME_FAILURE';
export const DEVICE_NAME_CHECK_ABORT = 'CREATED_DEVICES/NAME_ABORT';

export const PERSISTED_DEVICES = [SET_FILTER, CLEAR_FILTER, REMOVE_FILTER];

export const OPEN_CREATE_DEVICE_MODAL = 'DEVICES/CREATION_MODAL/OPEN';
export const HIDE_CREATE_DEVICE_MODAL = 'DEVICES/CREATION_MODAL/HIDE';

export const SEND_BY_EMAIL = 'DEVICES/SEND/BY_EMAIL/POST/REQUEST';
export const SEND_BY_EMAIL_SUCCESS = 'DEVICES/SEND/BY_EMAIL/POST/SUCCESS';
export const SEND_BY_EMAIL_FAILURE = 'DEVICES/SEND/BY_EMAIL/POST/FAILURE';

export const FETCH_DEVICE = 'DEVICE/FETCH_REQUEST';
export const FETCH_DEVICE_SUCCESS = 'DEVICE/FETCH_SUCCESS';
export const FETCH_DEVICE_FAILURE = 'DEVICE/FETCH_FAILURE';

export const PATCH_DEVICE = 'DEVICE/PATCH_REQUEST';
export const PATCH_DEVICE_SUCCESS = 'DEVICE/PATCH_SUCCESS';
export const PATCH_DEVICE_FAILURE = 'DEVICE/PATCH_FAILURE';

export const SELECT_DEVICE = 'DEVICE/SELECT';
export const SET_UPDATE_MODAL_VISIBILITY = 'DEVICE/MODAL/UPDATE/SET_VISIBILITY';

export const FETCH_DEVICES_APP_REQUEST = 'DEVICES/APP/FETCH/REQUEST';
export const FETCH_DEVICES_APP_SUCCESS = 'DEVICES/APP/FETCH/SUCCESS';
export const FETCH_DEVICES_APP_FAILURE = 'DEVICES/APP/FETCH/FAILURE';

export const FETCH_DEVICES_OS_VERSION_REQUEST = 'DEVICES/OS/FETCH/REQUEST';
export const FETCH_DEVICES_OS_VERSION_SUCCESS = 'DEVICES/OS/FETCH/SUCCESS';
export const FETCH_DEVICES_OS_VERSION_FAILURE = 'DEVICES/OS/FETCH/FAILURE';
